import { 
  UserType, 
  UserTypeSuperAdmin,
  UserTypeAdmin,
  UserTypeAgent,
  UserTypeGeneralManager,
  UserTypeSiteManager,
  UserTypeOperator
 } from "@/slicers/users";

export const getRoleByUserType = (userType: UserType): string => {
  switch (userType) {
      case UserTypeSuperAdmin:
        return 'superAdmin';
      case UserTypeAdmin:
        return 'admin';
      case UserTypeAgent:
        return '代理店管理者';
      case UserTypeGeneralManager:
        return '企業管理者';
      // case UserTypeManager: //今は使われていない権限
      //     return ''
      case UserTypeSiteManager:
        return '現場管理者';
      case UserTypeOperator:
        return '使用者';
      default:
        return 'ユーザー';
  }
};
